import { inferLiteral } from "client/utils"
import * as types from "./types"

// eslint-disable-next-line import/prefer-default-export
export const setHelpList = (helpList: types.HelpList) => ({
    type: inferLiteral(types.HELP_LIST),
    helpList,
})
